import {Injectable} from "@angular/core";
import {CoreErrorHandlerBaseService} from "@core/services/error-handler-base/core-error-handler-base.service";
import {IAlertControllerCreate} from "@shared/interfaces/alert-controller-create.interface";

@Injectable({
  providedIn: 'root'
})
export class TechErrorHandlerResourceService extends CoreErrorHandlerBaseService {
  override _formatAlertFor404(status: number, name: string, message: any): IAlertControllerCreate {
    const wholeRoutePath: string[] = this._router.url.split('/'); // Ex: tech/logged/inventory/mission/23180/resource/45037/view
    const missionIdRoutePath: string[] = wholeRoutePath.slice(0, -3);

    return {
      header: this._translateService.instant("TECH.INVENTORY.PAGES.RESOURCES.ERRORS.404.HEADER"),
      message: this._translateService.instant("TECH.INVENTORY.PAGES.RESOURCES.ERRORS.404.MESSAGE"),
      buttons: [
        {
          text: this._translateService.instant("TECH.INVENTORY.PAGES.RESOURCES.ERRORS.404.BUTTON"),
          handler: async () => {
            await this._router.navigate(missionIdRoutePath);
          }
        }
      ]
    };
  }
}
